import React, { useEffect, useState, Fragment } from "react";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights.jsx";
import Cookies from "js-cookie";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Defaultimg from "../../Webiste/assets/Frame.png";
import { BsSearch } from "react-icons/bs";
import "../Components/CSS/RaceCardCSS/racecard.css";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import HorseModal from "../Components/Modal/HorseModal.js";
import JockeyModal from "../Components/Modal/JockeyModal.js";
import TrainerModal from "../Components/Modal/TrainerModal.js";
import OwnerModal from "../Components/Modal/OwnerModal.js";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchAtoZReport } from "../redux/getReducer/getAtoZReport.js";
import ExNews from "../Components/Home/Components/ExNews.jsx";
import Search from "../Components/Home/Components/Search.jsx";
import Notification from "../Components/Home/Components/Notification.jsx";
import Language from "../Components/Home/Components/Language.jsx";

import { getBaseUrl } from "../service/apiUrl";
export default function AtoZReport() {
  const navigate = useNavigate();
  const [userIsDesktop, setUserIsDesktop] = useState(true);
  function handleRedirect(id) {
    if (userIsDesktop === true) {
      navigate("/racedetail", {
        state: {
          id: id,
        },
      });
    } else {
      navigate("/racedetails", {
        state: {
          id: id,
        },
      });
    }
  }

  const { data: AtoZReport } = useSelector((state) => state.AtoZReport);
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();

  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const [showTrainer, setShowTrainer] = useState(false);
  const [modaldataTrainer, setmodaldataTrainer] = useState();

  const handleCloseTrainer = () => setShowTrainer(false);
  const handleShowTrainer = (data) => { const id = data?._id || data; if (id) navigate("/trainer-detail?" + id); };

  const [showOwner, setShowOwner] = useState(false);
  const [modaldataOwner, setmodaldataOwner] = useState();

  const handleCloseOwner = () => setShowOwner(false);
  const handleShowOwner = (data) => { const id = data?._id || data; if (id) navigate("/owner-detail?" + id); };

  useEffect(() => {
    if (AtoZReport && AtoZReport?.length == undefined) {
    }
    dispatch(fetchAtoZReport());
  }, []);

  const GetDates = (alldata) => {
    var start = new Date();
    var end = new Date(start);

    end.setDate(start.getDate() + 3);
    let Dates = [];

    var loop = new Date(start);

    for (let i = 0; i < 5; i++) {
      if (i == 0) {
        var newDates = loop.setDate(loop.getDate() + i);
        loop = new Date(newDates);
        Dates.push(moment(loop).format("YYYY-MM-DD"));
      } else {
        var newDates = loop.setDate(loop.getDate() - 1);
        loop = new Date(newDates);
        Dates.push(moment(loop).format("YYYY-MM-DD"));
      }
    }

    // SetDateTobeDone(Dates);
    return Dates;
  };

  const AllTime = (TimeData) => {
    if (TimeData.length == 1) {
      return `${moment(TimeData[0].StartTime).format("HH:mm")}`;
    } else if (TimeData.length == 0) {
      return ``;
    } else {
      let FirstTime = moment(TimeData[0].StartTime).format("HH:mm");
      let LastTime = moment(TimeData[TimeData.length - 1].StartTime).format(
        "HH:mm",
      );
      return `${FirstTime}-${LastTime}`;
    }
  };

  function toPascalCase(inputString) {
    // Split the string into words
    const words = inputString.split(/\s+/);

    // Capitalize the first letter of each word
    const pascalCaseWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    // Join the words back together with spaces
    const pascalCaseString = pascalCaseWords.join(" ");

    return pascalCaseString;
  }

  return (
    <Fragment>
      <>
        <div class="main-a-to-z-page atoz-wrapper">
          <div className="new-to-container new-to-mystages">
            <div className="row">
              <div className="col-sm-12">
                <div className="new-to-raceCarParent">
                  <div className="new-to-raceCardHeader">
                    <h1 class="arabic-label">{t("AZReport")}</h1>
                  </div>

                  <div className="new-to-grid-table-wrapper">
                    {/* Condition check */}

                    {AtoZReport && AtoZReport.length > 0 ? (
                      <div className="new-to-grid-table">
                        <div className="new-to-grid-thead">
                          <div className="new-to-th">{t("Date")}</div>
                          <div className="new-to-th">{t("Time")}</div>
                          <div className="new-to-th">{t("Race course")}</div>
                          <div className="new-to-th">{t("Gate No")}</div>
                          <div className="new-to-th">{t("Horse No")}</div>
                          <div className="new-to-th">{t("Silk Color")}</div>
                          <div className="new-to-th">{t("Horse Name")}</div>
                          <div className="new-to-th">{t("Trainer")}</div>
                          <div className="new-to-th">{t("Jockey")}</div>
                          <div className="new-to-th">{t("Owner")}</div>
                        </div>

                        {/* --- DIV BASED BODY --- */}
                        <div className="new-to-grid-tbody">
                          {AtoZReport.map((singlecompetition, compIdx) => (
                            <Fragment key={compIdx}>
                              {singlecompetition.RacehorsesData ? (
                                singlecompetition.RacehorsesData.map(
                                  (Competitiondetail, horseIdx) => (
                                    <div
                                      key={horseIdx}
                                      className="new-to-grid-row-card"
                                    >
                                      {/* Date Column */}
                                      <div className="new-to-td">
                                        {moment(
                                          singlecompetition.StartTime,
                                        ).format("DD/MM/YYYY")}
                                      </div>

                                      {/* Time Column */}
                                      <div className="new-to-td">
                                        {moment(
                                          singlecompetition.StartTime,
                                        ).format("HH:mm")}
                                      </div>

                                      {/* Race Course Column */}
                                      <div className="new-to-td">
                                        {cookiedata === "en"
                                          ? toPascalCase(
                                              singlecompetition.RaceCourseData
                                                .TrackNameEn,
                                            )
                                          : singlecompetition.RaceCourseData
                                              .TrackNameAr}
                                      </div>

                                      {/* Gate No Column */}
                                      <div className="new-to-td">
                                        {Competitiondetail.GateNo ||
                                          "not available"}
                                      </div>

                                      {/* Horse No Column */}
                                      <div className="new-to-td">
                                        {Competitiondetail.HorseNo ||
                                          "not available"}
                                      </div>

                                      {/* Silk Color Image Column */}
                                      <div className="new-to-td new-to-img-cell">
                                        <img
                                          src={
                                            Competitiondetail.CapColorData1
                                              ? Competitiondetail.CapColorData1
                                                  .OwnerSilkColor
                                              : Defaultimg
                                          }
                                          alt="Silk"
                                        />
                                      </div>

                                      {/* Horse Name Column (Clickable) */}
                                      <div
                                        className="new-to-td new-to-clickable"
                                        onClick={() =>
                                          handleShow(
                                            Competitiondetail.HorseModelIdData1
                                              ? Competitiondetail
                                                  .HorseModelIdData1._id
                                              : "",
                                          )
                                        }
                                      >
                                        {Competitiondetail.HorseModelIdData1 &&
                                        cookiedata === "en"
                                          ? toPascalCase(
                                              Competitiondetail
                                                .HorseModelIdData1.NameEn,
                                            )
                                          : Competitiondetail.HorseModelIdData1
                                              ?.NameAr}
                                      </div>

                                      {/* Trainer Column (Clickable) */}
                                      <div
                                        className="new-to-td new-to-clickable"
                                        onClick={() =>
                                          handleShowTrainer(
                                            Competitiondetail.TrainerOnRaceData1
                                              ? Competitiondetail
                                                  .TrainerOnRaceData1._id
                                              : "",
                                          )
                                        }
                                      >
                                        {Competitiondetail.TrainerOnRaceData1 &&
                                        cookiedata === "en"
                                          ? toPascalCase(
                                              Competitiondetail
                                                .TrainerOnRaceData1.NameEn,
                                            )
                                          : Competitiondetail.TrainerOnRaceData1
                                              ?.NameAr}
                                      </div>

                                      {/* Jockey Column (Clickable) */}
                                      <div
                                        className="new-to-td new-to-clickable"
                                        onClick={() =>
                                          handleShowJockey(
                                            Competitiondetail.JockeyOnRaceData1
                                              ? Competitiondetail
                                                  .JockeyOnRaceData1._id
                                              : "",
                                          )
                                        }
                                      >
                                        {Competitiondetail.JockeyOnRaceData1 ===
                                        null
                                          ? "-"
                                          : cookiedata === "en"
                                          ? toPascalCase(
                                              Competitiondetail
                                                .JockeyOnRaceData1.NameEn,
                                            )
                                          : Competitiondetail.JockeyOnRaceData1
                                              .NameAr}
                                      </div>

                                      {/* Owner Column (Clickable) */}
                                      <div
                                        className="new-to-td new-to-clickable"
                                        onClick={() =>
                                          handleShowOwner(
                                            Competitiondetail.OwnerOnRaceData1
                                              ? Competitiondetail
                                                  .OwnerOnRaceData1._id
                                              : "",
                                          )
                                        }
                                      >
                                        {Competitiondetail.OwnerOnRaceData1 ===
                                        null
                                          ? "-"
                                          : cookiedata === "en"
                                          ? toPascalCase(
                                              Competitiondetail.OwnerOnRaceData1
                                                .NameEn,
                                            )
                                          : Competitiondetail.OwnerOnRaceData1
                                              .NameAr}
                                      </div>
                                    </div>
                                  ),
                                )
                              ) : (
                                <div className="new-to-no-data">
                                  No data found
                                </div>
                              )}
                            </Fragment>
                          ))}
                        </div>
                      </div>
                    ) : (
                      // --- "NO RECORD FOUND"  ---
                      <div className="custom-no-record-wrapper">
                        <div className="custom-icon-bg">
                          <BsSearch className="custom-no-record-icon" />
                        </div>
                        <h3>NO RECORD FOUND</h3>
                        <p>
                          We couldn't find any data at this moment. Maybe try
                          selecting a different date or check back later.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>


          <Modal
            show={showJockey}
            onHide={handleCloseJockey}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <JockeyModal data={modaldataJockey} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <Modal
            show={showTrainer}
            onHide={handleCloseTrainer}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <TrainerModal data={modaldataTrainer} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal
            show={showOwner}
            onHide={handleCloseOwner}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <OwnerModal data={modaldataOwner} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </div>
        <Footer />
        <CoptRight />
      </>
    </Fragment>
  );
}
